var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.params.data.project_id > 0)?_c('vs-chip',{staticClass:"mr-3",staticStyle:{"height":"60%","top":"20%"},attrs:{"color":"primary"}},[_vm._v("P")]):_vm._e(),_vm._v(_vm._s(_vm.params.value)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }